<template>
<!-- 顶部全屏按钮 -->
  <div class="item">
    <el-tooltip style="font-size: 23px;" effect="dark" :content="TopContent" placement="bottom">
      <i class="iconfont iconziyuan" @click='clickTopping' :style="`margin-right:10px;color: ${color}`"></i>
    </el-tooltip>
    <el-tooltip style="font-size: 25px;" effect="dark" :content="ScreenContent" placement="bottom">
      <i :class="icon" id="screen" @click='clickFullscreen'></i>
    </el-tooltip>
  </div>
</template>

<script>
import screenfull from 'screenfull'
export default {
  name: 'screenfull',
  data () {
    return {
      isFullscreen: false,
      icon: 'iconfont iconquanping',
      color: 'black',
      ScreenContent: '全屏',
      TopContent: '固定顶部栏',
      TopVal: false,
    }
  },
  methods: {
    clickFullscreen () {
      if (!screenfull.isEnabled) {
        this.$message({
          message: '你的浏览器不支持全屏',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle()
      this.icon === 'iconfont iconquanping' ? this.icon = 'iconfont icontuichuzhuanhuan' : this.icon = 'iconfont iconquanping'
      this.ScreenContent === '全屏' ? this.ScreenContent = '退出全屏' : this.ScreenContent = '全屏'
    },

    clickTopping(){
      this.color === 'black' ? this.color = 'blue' : this.color = 'black'
      this.TopContent === '固定顶部栏' ? this.TopContent = '取消固定' : this.TopContent = '固定顶部栏'
      this.TopVal === false ? this.TopVal = true : this.TopVal = false
      this.$store.dispatch('settings/changeSetting', {
          key: 'fixedHeader',
          value: this.TopVal
      })
    }
  }
}
</script>

<style scoped>
.item {
  font-size: 25px;
  cursor: pointer;
  margin: 0px 10px 0 0;

}
</style>
